import { Button, Divider, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import arrowDownIcon from "../../assets/images/arrow-down.svg";
import useStore from "../../store/useStore";
import { AUTH_TOKEN } from "../../utils/constants";
import {
    deleteKeysFromLocalStorage,
    getDecodedToken,
    getLocalStorage,
    setLocalStorage
} from "../../utils/localStorage";
import SpecializationSheet from "../account/components/SpecializationSheet";
import { fetchSpecialities } from "../tatvaShots/service";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import { register } from "./service";

interface Speciality {
    label: string;
    value: string;
    displayName: string;
    id: string;
}

const getDoctorSpecialities = async (
    setSpecialities: React.Dispatch<React.SetStateAction<Speciality[]>>,
    setSpeciality: React.Dispatch<React.SetStateAction<Speciality | null>>
) => {
    try {
        const res = await fetchSpecialities();
        if (res?.speciality?.length) {
            const formattedSpecialities: Speciality[] = res.speciality.map((s: any) => ({
                label: s.displayName,
                value: s.code,
                displayName: s.displayName,
                id: s.id,
            }));

            setSpecialities(formattedSpecialities);

            const selectedSpeciality = formattedSpecialities.find(s => s.displayName === "Gynaecology") || null;
            setSpeciality(selectedSpeciality);
        }
    } catch (error) {
        console.error("Error fetching specialities:", error);
    }
};

const Speciality = () => {
    const navigate = useNavigate();
    const { doctorDetails, setDoctorDetails } = useStore((state) => ({
        doctorDetails: state.doctorDetails,
        setDoctorDetails: state.setDoctorDetails,
    }));

    const [loading, setLoading] = useState(false);
    const [speciality, setSpeciality]: any = useState({});
    const [specialities, setSpecialities]: any = useState<Speciality[]>([]);
    const [show, setShow] = useState(false);


    useEffect(() => {
        if (!doctorDetails?.mobileNumber) {
            navigate("/on-boarding");
        }
        getDoctorSpecialities(setSpecialities, setSpeciality);
    }, []);

    const continueBtnHandler = async () => {
        setLoading(true);

        const firstName = getLocalStorage("firstName");
        const lastName = getLocalStorage("lastName");

        const res: any = await register({
            mobileNumber: "91" + doctorDetails?.mobileNumber,
            firstname: firstName,
            lastname: lastName,
            speciality: speciality?.value,
        });

        if (res?.data?.data?.status === 200) {
            setLocalStorage(AUTH_TOKEN, res?.data?.data?.data?.token);
            const decodedToken = getDecodedToken();
            setDoctorDetails({ ...doctorDetails, ...decodedToken });
            deleteKeysFromLocalStorage(["firstName", "lastName"]);
            navigate("/refer?skip=true");
        }
        else {
            console.error("Registration failed:", res?.data?.message || "Unknown error");
        }

        setLoading(false);
    };

    const backBtnHandler = () => {
        navigate("/personal-details");
    };

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault(); // Prevent the default dropdown behavior
        setShow(true);
    };

    const handleSpeciality = (speciality: any) => {
        setSpeciality(speciality);
        setShow(false);
    };

    const closeSheet = () => {
        setShow(false);
    }

    return (
        <div className="flex flex-col justify-between h-full">
            <div className="flex flex-col items-start p-6">
                <img
                    className="me-0"
                    height={22}
                    width={22}
                    src={arrowLeft}
                    alt="Youtube"
                    onClick={backBtnHandler}
                />
                <div className="text-left text-lg xs:text-xl xsPlus:text-2xl font-semibold pb-4 pt-4">
                    Please enter your speciality
                </div>
                <div className="w-full text-left">
                    Core Specialisation <span className="text-red-500">*</span>
                    <div
                        className="flex items-center mt-1 w-full text-base text-gray-500 bg-white rounded-xl border border-solid border-slate-300 min-h-[56px]">
                        <div
                            onClick={handleClick}
                            className="flex flex-1 shrink gap-2 justify-between items-center px-3 py-2 basis-0 min-w-[240px] size-full"
                        >
                            <span>
                                {speciality?.displayName || "Select Speciality"}
                            </span><img loading="lazy" src={arrowDownIcon} alt="Arrow Down" />
                        </div>
                    </div>
                </div>
            </div>
            {specialities?.length > 0 && <SpecializationSheet
                show={show}
                closePopup={closeSheet}
                handleSpeciality={handleSpeciality}
                specialities={specialities}
            />}
            <div className="w-full absolute bottom-6 left-0">
                <div className="flex flex-col items-center max-w-[1280px] w-full">
                    <Divider />
                    <Button
                        type="primary"
                        className="w-[85%] h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
                        onClick={continueBtnHandler}
                        disabled={!speciality?.value}
                        loading={loading}
                    >
                        Continue
                    </Button>
                </div>
            </div>
            {loading && <Spin />}
        </div>
    );
};

export default Speciality;